module.exports = __webpack_public_path__ + "static/media/activity-icon-draft-jury.15066a24.svg";